import { useQuery } from '@tanstack/react-query';
import { admin } from './admin-api';

const ENGINE_DESC: Record<string, { label: string; color: string }> = {
  scoring:    { label: 'Scoring',     color: 'var(--amber)' },
  router:     { label: 'Signal router', color: 'var(--teal)' },
  drift:      { label: 'Drift packet', color: 'var(--red)' },
  wargame:    { label: 'War game',     color: 'var(--gold)' },
  montecarlo: { label: 'Monte Carlo',  color: 'var(--blue)' },
  learning:   { label: 'Learning loop', color: 'var(--olive)' },
};

export default function Engines() {
  const engines = useQuery({ queryKey: ['admin', 'engines'], queryFn: admin.engines, refetchInterval: 10000 });
  if (engines.isLoading) return <div className="small faint">Loading engine telemetry…</div>;
  if (engines.isError) return <div className="login-err">Could not load engine telemetry.</div>;
  const data = engines.data!;

  return (
    <div>
      <div className="ph">Admin · Engines</div>
      <div className="h2">Engine telemetry</div>
      <p className="lead">Invocation counts, last seed, last call time. Updates every 10 seconds.</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
        {Object.entries(data).map(([name, info]) => {
          const desc = ENGINE_DESC[name] ?? { label: name, color: 'var(--muted)' };
          return (
            <div key={name} className="panel">
              <div className="qhead"><span className="qdot" style={{ background: desc.color }} />{desc.label}</div>
              <div className="kpi">
                <div className="num">{info.invocations}</div>
                <div className="lab">invocations since boot</div>
              </div>
              <div className="divider" />
              <div className="small">
                {info.last_seed != null && <div>Seed: <span className="mono">{info.last_seed}</span></div>}
                {info.last_invocation_at && (
                  <div>Last call: <span className="mono">{new Date(info.last_invocation_at).toLocaleTimeString()}</span></div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
